import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Stack,
  Checkbox,
  FormControlLabel,
  Grid,
} from '@mui/material';

const Checklist = ({ onComplete }) => {
  const [checkedItems, setCheckedItems] = useState({
    fatoora: false,
    vat: false,
    documents: false,
    contact: false
  });

  const checklistItems = [
    {
      id: 'fatoora',
      title: 'Fatoora Portal Access',
      description: 'Ensure you have access to the Fatoora portal',
      arDescription: 'تأكد من أن لديك حق الوصول إلى بوابة فاتورة'
    },
    {
      id: 'vat',
      title: 'VAT Registration',
      description: 'Verify your VAT registration is active',
      arDescription: 'تأكد من أن تسجيل ضريبة القيمة المضافة نشط'
    },
    {
      id: 'documents',
      title: 'Business Documents',
      description: 'Prepare your business registration documents',
      arDescription: 'قم بإعداد مستندات تسجيل الأعمال'
    },
    {
      id: 'contact',
      title: 'Contact Information',
      description: 'Ensure your contact information is up to date',
      arDescription: 'تأكد من تحديث معلومات الاتصال الخاصة بك'
    }
  ];

  const handleCheckboxChange = (id) => (event) => {
    setCheckedItems(prev => ({
      ...prev,
      [id]: event.target.checked
    }));
  };

  const isAllChecked = Object.values(checkedItems).every(value => value);

  return (
    <Box>
      <Card 
        variant="outlined" 
        sx={{ 
          mb: 4,
          borderRadius: 0,
          borderColor: 'divider',
          width: '100%',
          minHeight: 420
        }}
      >
        <CardContent>
          <Typography 
            variant="subtitle1" 
            sx={{ 
              mb: 2,
              fontWeight: 500,
              color: 'text.secondary',
              fontSize: '0.875rem'
            }}
          >
            Before proceeding with ZATCA onboarding, please ensure you have completed the following:
          </Typography>

          <Stack spacing={1}>
            {checklistItems.map((item) => (
              <Box
                key={item.id}
                sx={{
                  p: 1.5,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 0,
                  bgcolor: 'background.paper'
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox 
                      checked={checkedItems[item.id]}
                      onChange={handleCheckboxChange(item.id)}
                      sx={{ 
                        '&.Mui-checked': {
                          color: 'primary.main',
                        },
                        py: 0
                      }}
                    />
                  }
                  label={
                    <Box sx={{ width: '100%' }}>
                      <Typography 
                        variant="subtitle1" 
                        sx={{ 
                          fontWeight: 500,
                          color: 'text.primary',
                          lineHeight: 1.2,
                          mb: 0.5
                        }}
                      >
                        {item.title}
                      </Typography>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              color: 'text.secondary',
                              lineHeight: 1.2
                            }}
                          >
                            {item.description}
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              color: 'text.secondary',
                              textAlign: 'right',
                              direction: 'rtl',
                              lineHeight: 1.2
                            }}
                          >
                            {item.arDescription}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  }
                  sx={{ 
                    alignItems: 'flex-start',
                    margin: 0,
                    width: '100%',
                    '& .MuiFormControlLabel-label': {
                      flex: 1
                    }
                  }}
                />
              </Box>
            ))}
          </Stack>
        </CardContent>
      </Card>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          onClick={onComplete}
          disabled={!isAllChecked}
          sx={{ 
            px: 3,
            py: 1,
            borderRadius: 0,
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '0.875rem'
          }}
        >
          I have completed all requirements
        </Button>
      </Box>
    </Box>
  );
};

export default Checklist; 